var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "back-profile",
        {
          nativeOn: {
            click: function($event) {
              return _vm.navigateTo("app.profile.alerts")
            }
          }
        },
        [_vm._v("Volver a Alertas")]
      ),
      _vm._v(" "),
      _c(
        "block",
        { attrs: { "bordered-header": true } },
        [
          _c("template", { slot: "header" }, [
            _vm._v(_vm._s(_vm.alertTitle(_vm.studentAlert)))
          ]),
          _vm._v(" "),
          _c("template", { slot: "subheader" }, [
            _vm._v(_vm._s(_vm._f("humanizeDate")(_vm.studentAlert.createdAt)))
          ]),
          _vm._v(" "),
          _vm.viewer && _vm.viewer.institutionCode === "cuc.co"
            ? _c("div", [
                _vm.studentAlert.alertType
                  ? _c(
                      "div",
                      [
                        _c("student-alert-reason", {
                          attrs: { alert: _vm.getAlertObject() }
                        }),
                        _vm._v(" "),
                        _vm.studentAlertReasonWasExposed(
                          _vm.studentAlert.alertType,
                          _vm.studentAlert.alertType.id
                        )
                          ? _c("hr", { staticClass: "separator" })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "meta-list" }, [
            _c("div", { staticClass: "meta-item" }, [
              _c("span", { staticClass: "meta-name has-text-weight-bold" }, [
                _vm._v("Fecha:")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "meta-value" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatStandardDate")(_vm.studentAlert.createdAt)
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "meta-item" }, [
              _c("span", { staticClass: "meta-name has-text-weight-bold" }, [
                _vm._v("Registrado por:")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "meta-value" }, [
                _vm._v(
                  _vm._s(
                    _vm.studentAlert.creator
                      ? _vm.studentAlert.creator.name
                      : ""
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "meta-item" }, [
              _c("span", { staticClass: "meta-name has-text-weight-bold" }, [
                _vm._v("Responsable:")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "meta-value" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.studentAlert.responsible
                        ? _vm.studentAlert.responsible.name
                        : ""
                    ) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "meta-item" }, [
              _c("span", { staticClass: "meta-name has-text-weight-bold" }, [
                _vm._v("Factor de Riesgo:")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "meta-value" }, [
                _vm._v(_vm._s(_vm.alertRiskFactors))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.studentAlert.comment))
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }